import { useBackOfficeProjects } from '@/services/projectBackOffice.service';
import { DEFAULT_PROJECT_ID } from '@/lib/defaultProject';

/** The live projects to put something in, the default one first, then by
 *  name; each with our internal label, to tell look-alikes apart. */
export default function ProjectSelect({
    value,
    onChange,
}: {
    value: string;
    onChange: (projectId: string) => void;
}) {
    const { data: projects } = useBackOfficeProjects();
    const choices = (projects ?? [])
        .filter((p) => !p.softDelete)
        .sort(
            (a, b) =>
                Number(b.id === DEFAULT_PROJECT_ID) -
                    Number(a.id === DEFAULT_PROJECT_ID) ||
                a.name.localeCompare(b.name),
        );
    return (
        <select
            value={value}
            onChange={(e) => onChange(e.target.value)}
            className="w-full h-10 rounded-md border px-3 text-sm bg-[#0f141a] border-[#1e242a] text-[#e5e7e3] focus:outline-none focus:border-[#2d6a4f]"
        >
            <option value="" disabled>
                —
            </option>
            {choices.map((p) => (
                <option key={p.id} value={p.id}>
                    {p.internalTeamOnlyLabel
                        ? `${p.name} · ${p.internalTeamOnlyLabel}`
                        : p.name}
                </option>
            ))}
        </select>
    );
}
